import { api } from '@/services';

export default {
  async atualizarCotacoesAtuais({ state, dispatch, commit }) {
    return Object.values(state.moedas).map(async (moeda) => {
      dispatch('fetchCotacao', moeda).then((cotacao) => {
        commit('SET_COTACAO', cotacao);
      });
    });
  },
  async fetchCotacao(context, moeda) {
    return api.get(`/cotacao/${moeda}`).then((response) => response.data);
  },
};
